// Floating calendar-day math — mirrors OfficeHeaderNav.toDate so 'YYYY-MM-DD'
// buckets line up with the rest of the dashboard in every browser timezone.
const parseDay = (s) => {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
};
const fmtDay = (dt) =>
  `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
const addDays = (dt, n) => { const c = new Date(dt); c.setDate(c.getDate() + n); return c; };
const startOfWeek = (dt) => { const c = new Date(dt); c.setDate(c.getDate() - ((c.getDay() + 6) % 7)); return c; }; // Mon start

// Map a preset -> concrete { start, end, bucket }.
// endDate/startFloor come straight from the response (endDate, startDate).
// week/month are TRAILING windows; ytd/all are calendar-anchored. (See note below.)
export function getRange(preset, endDate, startFloor) {
  const end = parseDay(endDate);
  const floor = parseDay(startFloor);
  let start, bucket;

  switch (preset) {
    case 'week':  start = addDays(end, -6);  bucket = 'day';   break;
    case 'month': start = addDays(end, -29); bucket = 'day';   break;
    case 'ytd':   start = new Date(end.getFullYear(), 0, 1); bucket = 'month'; break;
    case 'all':
    default:      start = floor; bucket = 'month'; break;
  }
  if (start < floor) start = floor; // never before we have data
  return { start: fmtDay(start), end: endDate, bucket };
}

function bucketOf(dt, bucket) {
  if (bucket === 'week') {
    const ws = startOfWeek(dt);
    return { key: fmtDay(ws), label: ws.toLocaleDateString([], { month: 'short', day: 'numeric' }), start: fmtDay(ws) };
  }
  if (bucket === 'month') {
    const key = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`;
    return { key, label: dt.toLocaleDateString([], { month: 'short', year: 'numeric' }), start: `${key}-01` };
  }
  return { key: fmtDay(dt), label: dt.toLocaleDateString([], { month: 'short', day: 'numeric' }), start: fmtDay(dt) };
}

// series: sparse [{ date:'YYYY-MM-DD', count, countOut }] (dailySeries or perDoorDaily[id])
// Walks every day in [start,end] so gaps zero-fill, then buckets + sums.
// Returns { buckets: [{ label, start, count, countOut }], totals: { entrances, exits } }.
export function rollupSeries(series, { start, end, bucket }) {
  const byDay = new Map((series || []).map(p => [p.date, p]));
  const s = parseDay(start), e = parseDay(end);

  const buckets = new Map();
  let totalIn = 0, totalOut = 0;

  for (let d = new Date(s); d <= e; d = addDays(d, 1)) {
    const rec = byDay.get(fmtDay(d));
    const inV = rec?.count || 0;
    const outV = rec?.countOut || 0;
    totalIn += inV; totalOut += outV;

    const { key, label, start: bStart } = bucketOf(d, bucket);
    let b = buckets.get(key);
    if (!b) { b = { label, start: bStart, count: 0, countOut: 0 }; buckets.set(key, b); }
    b.count += inV; b.countOut += outV;
  }

  return { buckets: Array.from(buckets.values()), totals: { entrances: totalIn, exits: totalOut } };
}